"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_TO_ROOMS = exports.SUBSCRIBE_TO_ROOM = exports.DIRECTOR_SESSION = exports.BROADCAST_PREFIX = exports.BROADCAST_JOIN_SYNC_SERVER_TIME = exports.BROADCAST_DIRECTOR_PREFIX = void 0;
var DIRECTOR_SESSION = exports.DIRECTOR_SESSION = 'directorSession';
var BROADCAST_PREFIX = exports.BROADCAST_PREFIX = 'broadcast';
var BROADCAST_DIRECTOR_PREFIX = exports.BROADCAST_DIRECTOR_PREFIX = 'broadcastDirector';
var BROADCAST_JOIN_SYNC_SERVER_TIME = exports.BROADCAST_JOIN_SYNC_SERVER_TIME = 'broadcastJoinSyncServerTime';
var SUBSCRIBE_TO_ROOMS = exports.SUBSCRIBE_TO_ROOMS = 'SUBSCRIBE_TO_ROOMS';
var SUBSCRIBE_TO_ROOM = exports.SUBSCRIBE_TO_ROOM = 'SUBSCRIBE_TO_ROOM';